import { render, staticRenderFns } from "./MidiInputEdit.vue?vue&type=template&id=1a7f87cd&scoped=true&"
import script from "./MidiInputEdit.vue?vue&type=script&lang=js&"
export * from "./MidiInputEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f87cd",
  null
  
)

export default component.exports